// removed by extract-text-webpack-plugin
module.exports = {"body":"BodyTemplate__body___EDDwh"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/templates/BodyTemplate.less
 ** module id = 753
 ** module chunks = 0
 **/